import { Space, Typography } from "antd";

import { FC } from "react";
import { useTheme } from "../../../../Styles/ThemeHook";
import { SqftIcon } from "shared-components/Components/CustomIcons/SqftIcon/web";
import { SquareM2Icon } from "shared-components/Components/CustomIcons/SquareM2Icon/web";

interface M2TagProps {
	m2: number;
	icon?: boolean;
	hectares?: number;
	isEspecial?: Boolean;
	isMin?: Boolean;
}

export const M2Tag: FC<M2TagProps> = ({ m2, icon = false, hectares = 0, isEspecial, isMin = false }) => {
	const { theme } = useTheme();

	return (
		<Space size={theme.spacing.smSpacing}>
			{isEspecial ? (
				<>
					{icon && <SqftIcon className="icon" />}
					<div style={{ display: "flex", flexDirection: "column" }}>
						<Typography.Text className="name" ellipsis>
							{"SQFT"}
						</Typography.Text>
						<Typography.Text className="count" ellipsis>
							{isMin ? "+" : ""}{hectares > 0 ? hectares : m2} {hectares > 0 ? 'hectáreas':'m²'}
						</Typography.Text>
					</div>
				</>
			) : (
				<>
					{icon && <SquareM2Icon style={{ color: theme.colors.textSecondaryColor }} />}
					<Typography.Text ellipsis>
						{isMin ? "+" : ""}{hectares > 0 ? hectares : m2} {hectares > 0 ? 'hectáreas':'m²'}
					</Typography.Text>
				</>
			)}
		</Space>
	);
};
